export class UserSearch {
  page: number = 1;
  pageSize: number = 25;
  sortDirection: string = "asc";
  sortColumn: string = "username";
  subscriptionLevels: string = "";
  search: string = "";
  createdStartDate?: Date = null;
  createdEndDate?: Date = null;
  isEnabled = true;
}
